import styled, { css } from 'styled-components/macro'
import palette from 'styles/palette'
import RatingStar from 'svg/rating-star.svg?react'
import StopPickup from 'svg/stop-pickup.svg?react'
import StopDelivery from 'svg/stop-delivery.svg?react'
import StopReturn from 'svg/stop-return.svg?react'
import Check from 'svg/check.svg?react'
import Lock from 'svg/lock.svg?react'
import Ban from 'svg/ban.svg?react'
import Shield from 'svg/shield.svg?react'
import ArrowRight from 'svg/arrow-right.svg?react'
import ArrowDownActive from 'svg/arrow-down-active.svg?react'
import ArrowDownDisabled from 'svg/arrow-down-disabled.svg?react'
import NewsPaper from 'svg/news-paper.svg?react'
import LoadingBar from 'svg/loading-bar.svg?react'
import MapIcon from 'svg/map.svg?react'
import Link from 'svg/icon-hyperlink.svg?react'
import Logo from 'svg/logo.svg?react'
import CheckCircle from 'svg/check-circle.svg?react'
import PaymentCreditCardHelper from 'svg/payment-cc-helper.svg?react'
import Cross from 'svg/cross.svg?react'
import Edit from 'svg/edit.svg?react'
import Plus from 'svg/plus.svg?react'
import Alert from 'svg/foundation-icons-alert-circle-md.svg?react'
import ExternalLinkActive from 'svg/external-link-active.svg?react'
import ExternalLinkDisabled from 'svg/external-link-disabled.svg?react'
import VideoPlayCircled from 'svg/video-play-circled.svg?react'

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    display: block;
    max-width: 100%;
    max-height: 100%;
  }

  svg .icon-stroke {
    stroke: currentColor;
  }
  svg .icon-fill {
    fill: currentColor;
  }

  ${(props) =>
    props.palette &&
    css`
      svg .icon-stroke {
        stroke: ${palette('base', 'grey')};
      }
      svg .icon-fill {
        fill: ${palette('base', 'grey')};
      }
    `}
`

const getSvg = (symbol) => {
  switch (symbol) {
    case 'star':
      return RatingStar
    case 'stop-pickup':
      return StopPickup
    case 'stop-delivery':
      return StopDelivery
    case 'stop-return':
      return StopReturn
    case 'check':
      return Check
    case 'lock':
      return Lock
    case 'ban':
      return Ban
    case 'shield':
      return Shield
    case 'arrow-right':
      return ArrowRight
    case 'arrow-down-active':
      return ArrowDownActive
    case 'arrow-down-disabled':
      return ArrowDownDisabled
    case 'external-link-active':
      return ExternalLinkActive
    case 'external-link-disabled':
      return ExternalLinkDisabled
    case 'logo':
      return Logo
    case 'news-paper':
      return NewsPaper
    case 'loading-bar':
      return LoadingBar
    case 'map':
      return MapIcon
    case 'link':
      return Link
    case 'check-circle':
      return CheckCircle
    case 'payment-cc-helper':
      return PaymentCreditCardHelper
    case 'alert':
      return Alert
    case 'cross':
      return Cross
    case 'edit':
      return Edit
    case 'plus':
      return Plus
    case 'video-play-circled':
      return VideoPlayCircled
    default:
      return RatingStar
  }
}

/**
 * The explicit JSDoc type keeps palette/shade/className optional for TSX
 * consumers — without it, parameter destructuring makes tsc infer them as
 * required props.
 *
 * @param {{ symbol?: string, palette?: string, shade?: string, className?: string, [prop: string]: any }} props
 */
const Icon = ({ palette, shade, className, ...props }) => {
  const SvgIcon = getSvg(props.symbol)

  return (
    <IconWrapper palette={palette} shade={shade} className={className}>
      <SvgIcon {...props} />
    </IconWrapper>
  )
}

export default Icon
